import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';
import { DialogModel } from './Dialog.model';

@Component
export default class DialogComponent<T> extends Vue {
    // Dialog props.
    @Prop() public title: string;
    @Prop() public content: string;
    @Model('change') public model: DialogModel<T>;

    // Main button.
    @Prop() public mainButtonActionText: string;

    // Secondary button.
    @Prop() public secondaryButtonActionText: string;
    @Prop() public hideSecondaryButton: boolean;

    /*
     * Outputs.
     * Le décorateur @Emit ne fonctionne pas :(.
     */
    public emitClose() {
        this.$emit('close', false);
    }

    public emitConfirm() {
        this.$emit('confirm', true);
    }
}
